import {Card} from 'platform/components';
import {match} from 'ts-pattern';

import {mergeAll} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {businessCaseRoutes, testIds} from '@dms/routes';
import {
  DmsDataGrid,
  type DmsDataGridProps,
  Main,
  openActivityChangeLog,
  PageTab,
} from '@dms/shared';

import {composePath, useRequiredParams} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['commandId'] as const;

export function BusinessCaseActivityLogs(props: Pick<DmsDataGridProps, 'maximization'>) {
  const {id} = useRequiredParams();

  const activityLogQueryModifier = (filter: QueryFilterObject) => mergeAll([filter, {record: id}]);

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = (data) => {
    const {actionKey, getColumnData} = data;
    const commandId = getColumnData('commandId')?.value;

    match(actionKey).with('detail', () => {
      if (commandId && typeof commandId === 'string') {
        openActivityChangeLog({
          resourceId: EntityResourceIds.businessCase,
          commandId,
          recordId: id,
        });
      } else {
        console.error('no command in row');
      }
    });
  };

  const tabs: PageTab[] = [
    {
      href: composePath(businessCaseRoutes.activityLog, {params: {id}}),
      content: (
        <Card
          title={i18n.t('general.labels.activityLogs')}
          isFullHeight
          key="activity-logs-datagrid"
        >
          <DmsDataGrid
            maximization={props.maximization}
            gridCode="business-case-audit-log"
            actionCallback={actionCallback}
            predefinedColumns={PREDEFINED_COLUMNS}
            queryModifier={activityLogQueryModifier}
            data-testid="activity-logs-datagrid"
          />
        </Card>
      ),
      id: 'business-case-audit-log',
      title: i18n.t('general.labels.activityLogs'),
      'data-testid': testIds.businessCase.activityLog('navigation-business-case-audit-log'),
    },
  ];

  return <Main tabs={tabs} isFullHeight />;
}
